import { ReactElement, useCallback, useMemo } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { useEventCallback } from '@mui/material';
import { generatePath, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import SipoPersonForm from 'shell/components/shared/sipo-person-form';
import PmiTitle from 'shell/components/shared/title';
import { __PERSON_API_URL__, __PERSON_NEW_API_URL__ } from 'shell/constants/environment';
import { BornAggregazioneCrumbs } from 'subscription/constants/breadcrumb';
import { SubjectData } from 'shell/models/person';
import { PersonalDataVM } from 'shell/view-models/personal-data';

const PersonSipoBornAggregazionePage = (): ReactElement => {
  const navigate = useNavigate();

  const [queryParams] = useSearchParams();

  const stateRequestApplicant = useLocation().state as PersonalDataVM;

  // id intestatrio se presente fare get perchè siamo in modifica
  const idIntestatario = queryParams.get('idIntestatario') || '';
  const idAnpr = queryParams.get('idAnpr') || '';

  const isEdit = useMemo(() => {
    if ((idIntestatario && idIntestatario !== '0') || (idAnpr && idAnpr !== '0')) {
      return true;
    }

    return false;
  }, [idIntestatario, idAnpr]);

  const handleOnSuccess = useEventCallback(
    (newIdIntestatario?: string, state?: { subjectData?: SubjectData }) => {
      queryParams.delete('idIntestatario');
      queryParams.delete('idAnpr');
      if (isEdit) {
        navigate(
          {
            pathname: generatePath('/iscrizioni/aire-nascita-aggregazione/trascrizione'),
            search: `?${queryParams.toString()}`,
          },
          {
            state: stateRequestApplicant,
          }
        );

        return;
      }

      navigate(
        {
          pathname: generatePath('/iscrizioni/aire-nascita-aggregazione/trascrizione'),
          search: `?${queryParams.toString()}`,
        },
        {
          state: { ...stateRequestApplicant, ...state },
        }
      );
    }
  );

  const handleExit = useCallback(() => {
    queryParams.delete('idIntestatario');
    queryParams.delete('idAnpr');
    navigate({
      pathname: generatePath('/iscrizioni/aire-nascita-aggregazione/trascrizione'),
      search: `?${queryParams.toString()}`,
    });
  }, []);

  return (
    <>
      <Breadcrumbs
        items={[
          ...BornAggregazioneCrumbs,
          {
            name: isEdit ? 'Modifica persona' : 'Nuova persona',
          },
        ]}
      />
      <PmiTitle title={isEdit ? 'Modifica persona' : 'Nuova persona'} />
      <SipoPersonForm
        onExit={handleExit}
        onSuccess={handleOnSuccess}
        urlGetData={
          idIntestatario && idIntestatario !== '0'
            ? `${__PERSON_API_URL__}/non-residenti/sipo/soggetto/${idIntestatario}`
            : `${__PERSON_NEW_API_URL__}/persona`
        }
        fiscalCode={stateRequestApplicant?.fiscalCode}
        urlRegistration={`${__PERSON_API_URL__}/non-residenti/registrazione-aire`}
        urlUpdate={`${__PERSON_API_URL__}/non-residenti/modifica`}
      />
    </>
  );
};

PersonSipoBornAggregazionePage.displayName = 'Person Sipo Edit Page component';

export default PersonSipoBornAggregazionePage;
